import{a as o}from"./chunk-2HA4XQFN.js";var t=o((e,r)=>{for(;e%r===0;)e/=r;return e===1},"isPowerOf");export{t as a};
